var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picture_1_",
    "data-name": "picture (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.453,
    height: 18.453,
    viewBox: "0 0 18.453 18.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15556",
    "data-name": "Path 15556",
    d: "M14.608,0H3.844A3.849,3.849,0,0,0,0,3.844V14.608a3.849,3.849,0,0,0,3.844,3.844H14.608a3.849,3.849,0,0,0,3.844-3.844V3.844A3.849,3.849,0,0,0,14.608,0ZM3.844,1.538H14.608a2.307,2.307,0,0,1,2.307,2.307V14.608a2.269,2.269,0,0,1-.231.988L9.639,8.551a3.844,3.844,0,0,0-5.437,0L1.538,11.215V3.844A2.307,2.307,0,0,1,3.844,1.538Zm0,15.377a2.307,2.307,0,0,1-2.307-2.307V13.389l3.75-3.751a2.307,2.307,0,0,1,3.263,0L15.6,16.684a2.269,2.269,0,0,1-.988.231Z",
    fill: "#1d2432"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15557",
    "data-name": "Path 15557",
    d: "M15.191,8.882A2.691,2.691,0,1,0,12.5,6.191a2.691,2.691,0,0,0,2.691,2.691Zm0-3.844a1.153,1.153,0,1,1-1.153,1.153A1.153,1.153,0,0,1,15.191,5.038Z",
    transform: "translate(-2.889 -0.809)",
    fill: "#1d2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.401c6bbc5439069edeb9b76813d2b0a9.svg";
export { ForwardRef as ReactComponent };